import { Alert, AlertTitle } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCircleInfo,
  faCircleXmark,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { VeBox, VeTypography } from "../../mui";

type AlertTypes = "success" | "error" | "info" | "warning";
interface alertOptions {
  heading?: string;
  paragraph?: any;
  alertType: AlertTypes;
  alertMarginBottom?: any;
  newAlert?: boolean;
  tertiaryAlertIcon?: any;
}
export function VEAlert({
  heading,
  paragraph,
  alertType,
  alertMarginBottom = "24px",
  newAlert = false,
  tertiaryAlertIcon,
}: alertOptions) {
  const backgroundColors: { [key in AlertTypes]: string } = {
    success: "#ebf9f3",
    error: "#fde7eb",
    info: "#ebf2fa",
    warning: "#fef7e7",
  };
  const alertIcons: { [key in AlertTypes]: JSX.Element } = {
    success: (
      <FontAwesomeIcon width={"15px"} height={"15px"} icon={faCircleCheck} />
    ),
    error: tertiaryAlertIcon ? (
      tertiaryAlertIcon
    ) : (
      <FontAwesomeIcon
        color={newAlert ? "rgba(61, 70, 90, 1)" : "#DE1135"}
        width={"15px"}
        height={"15px"}
        icon={faCircleXmark}
        unicode={"f057"}
      />
    ),
    warning: (
      <FontAwesomeIcon
        width={"15px"}
        color="#F6BC2F"
        height={"15px"}
        icon={faTriangleExclamation}
      />
    ),
    info: (
      <FontAwesomeIcon
        color="#2B6CB0"
        width={"15px"}
        height={"15px"}
        icon={faCircleInfo}
      />
    ),
  };
  return (
    <Alert
      icon={alertIcons[alertType]}
      sx={{
        backgroundColor: backgroundColors[alertType],
        width: "100%",
        borderRadius: "8px !important",
        marginBottom: alertMarginBottom, // Change this accordingly
        overflowY: "hidden !important",
      }}
    >
      <AlertTitle
        sx={{
          fontSize: "14px",
          fontWeight: "500px",
          lineHeight: "22px",
          color: "#1D2330",
          margin: !paragraph ? 0 : undefined,
        }}
      >
        {/* {heading} */}
        <VeBox display={"block"}>
          <VeTypography variant="body1StrongMain" fontSize={"14px"}>
            {heading}
          </VeTypography>
          <VeBox>
            <VeTypography variant="body2Secondary">{paragraph}</VeTypography>
          </VeBox>
        </VeBox>
      </AlertTitle>
    </Alert>
  );
}

export default VEAlert;
